import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Hero from '../../components/Hero/Hero';
import heroBg from '../../assets/images/hero/tspc-banner.png';
import './Products.css';

// Import all product images
import p5795 from '../../assets/images/products/gallery/product-5795.png';
import p5796 from '../../assets/images/products/gallery/product-5796.png';
import p5797 from '../../assets/images/products/gallery/product-5797.png';
import p5799 from '../../assets/images/products/gallery/product-5799.png';
import p5801 from '../../assets/images/products/gallery/product-5801.png';
import p5803 from '../../assets/images/products/gallery/product-5803.png';
import p5805 from '../../assets/images/products/gallery/product-5805.png';
import p5807 from '../../assets/images/products/gallery/product-5807.png';
import p5809 from '../../assets/images/products/gallery/product-5809.png';
import p5810 from '../../assets/images/products/gallery/product-5810.png';
import p5812 from '../../assets/images/products/gallery/product-5812.png';
import p5814 from '../../assets/images/products/gallery/product-5814.png';
import p5815 from '../../assets/images/products/gallery/product-5815.png';
import p5818 from '../../assets/images/products/gallery/product-5818.png';
import p5821 from '../../assets/images/products/gallery/product-5821.png';
import pGroup from '../../assets/images/products/gallery/product-group.jpg';

const products = [
  { src: p5795, title: 'Ultra Precise Shaft' },
  { src: p5796, title: 'Ultra Precise Shaft' },
  { src: p5797, title: 'Ultra Precise Shaft' },
  { src: p5799, title: 'Ultra Precise Shaft' },
  { src: p5801, title: 'Ultra Precise Shaft' },
  { src: p5803, title: 'Ultra Precise Shaft' },
  { src: p5805, title: 'Cutting Process Product' },
  { src: p5807, title: 'Cutting Process Product' },
  { src: p5809, title: 'Cutting Process Product' },
  { src: p5810, title: 'Cutting Process Product' },
  { src: p5812, title: 'Escomatic Process Product' },
  { src: p5814, title: 'Escomatic Process Product' },
  { src: p5815, title: 'Escomatic Process Product' },
  { src: p5818, title: 'Escomatic Process Product' },
  { src: p5821, title: 'Escomatic Process Product' },
  { src: pGroup, title: 'Product Collection' },
];

const Products = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  return (
    <div>
      <Hero title={<>Our <span className="highlight">Products</span></>} subtitle="Ultra precise stainless steel shafts manufactured with cutting-edge technology and rigorous quality control." backgroundImage={heroBg} />
      <section className="products section">
        <div className="container">
          <p className="section-label">Product Gallery</p>
          <h2 className="section-title">Precision <span className="highlight">Engineered</span></h2>
          <p className="products__desc">Tokyo Steel Philippines Corporation strives to become the preferred manufacturer and supplier of ultra precise shafts, delivering excellence through our cutting and escomatic processes.</p>
          <div className="products__grid">
            {products.map((p, i) => (
              <div className="products__item" key={i} onClick={() => { setLightboxIndex(i); setLightboxOpen(true); }}>
                <img src={p.src} alt={p.title} loading="lazy" />
                <div className="products__item-overlay"><span>{p.title}</span></div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Lightbox open={lightboxOpen} close={() => setLightboxOpen(false)} index={lightboxIndex} slides={products.map(p => ({ src: p.src, alt: p.title }))} />
    </div>
  );
};

export default Products;
